import {useSelector} from 'react-redux'
import './index.scss'
import classNames from 'classnames'

const InfoBox = ({children, description}) => {
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)

    return (
        <div className={classNames('info-container', {
            'dark': isDarkMode
        })}>
            <div className={`info ${!description ? 'border-none pb-0' : ''}`}>
                {children}
            </div>
            {description && <div className="info-description">{description}</div>}
        </div>
    )
}

export default InfoBox
